import React from 'react'
import { Progress as ProgressAntd, Typography } from 'antd'
import './Progress.scss'

const { Text } = Typography

interface IProps {
  value: number | undefined
}

const Progress = ({ value }: IProps) => {
  return (
    <div className="progress">
      <ProgressAntd
        showInfo={false}
        type="circle"
        strokeColor={'#50c32c'}
        percent={value}
        status="active"
      />
      <Text className="m__t--4">{`${value || 0}%`}</Text>
    </div>
  )
}

export default Progress
